import Vue from 'vue'
import api from '@/services/api'

function sleep(milliseconds = 1000) {
  return new Promise((resolve) => setTimeout(resolve, milliseconds))
}

/**
 * Download a program's workouts as an xlsx file matching the
 * Workout Ingestion Template format.
 *
 * @param {number|string} programId
 * @param {string} programName
 */
async function downloadProgramWorkouts(programId, programName = 'program') {
  const { data, headers } = await api.get(
    `programs/${programId}/workouts/export`,
    {
      responseType: 'blob',
    }
  )

  let fileName = `${programName}-workouts.xlsx`

  const disposition = headers['content-disposition']
  if (disposition) {
    const match = disposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i)
    if (match && match[1]) {
      fileName = decodeURIComponent(match[1])
    }
  }

  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

Vue.prototype.$sleep = sleep
Vue.prototype.$downloadProgramWorkouts = downloadProgramWorkouts

export { sleep, downloadProgramWorkouts }
